// @flow
import * as React from 'react';
import { listingSearchHomePath } from 'utils/searchHomePages';
import Box from 'components/Box';
import { H2 } from 'components/Text';
import { PrimaryButtonLink } from 'components/Button';
import { Card } from './CardsBlock';
import { gutterWidth, colors } from '../../../theme';

const Jobs = () => (
  <amp-list
    width="auto"
    height="100"
    layout="fixed-height"
    src="/data/website/search/latest-jobs"
    items="results"
    max-items="3"
  >
    <template type="amp-mustache">
      <Box
        display={('block', null, 'inline-block')}
        width={[1, null, 1 / 3]}
        verticalAlign="top"
        maxWidth={320}
        px={[0, null, gutterWidth / 2]}
        py={[gutterWidth / 2, null, 0]}
      >
        <Card
          card={{
            image: {
              filename: '{{logo.filename}}',
              handle: '{{logo.handle}}',
              mimetype: '{{logo.mimetype}}',
              size: parseInt('{{logo.size}}', 10),
              source: '{{logo.source}}'
            },
            headline: '{{name}}',
            text: '{{city}}, {{state}}',
            label: '{{orgName}}',
            urls: {
              en: '{{url.en}}',
              es: '{{url.es}}',
              pt: '{{url.pt}}'
            }
          }}
          imageSize="SMALL"
        />
      </Box>
    </template>
  </amp-list>
);

const CmsRecommendedJobsBlock = ({ headline }: { headline: string }) => (
  <Box
    mx={[-gutterWidth / 2, null, -gutterWidth]}
    p={[gutterWidth / 2, null, gutterWidth]}
    borderRadius={[0, null, null, 48]}
    bg={colors.fog}
    textAlign="center"
  >
    {headline && <H2>{headline}</H2>}
    <PrimaryButtonLink
      href={`${listingSearchHomePath('JOB')}?searchMode=true&q=`}
    >
      {getText('See All')}
    </PrimaryButtonLink>
    <Box mt={48}>
      <Jobs />
    </Box>
  </Box>
);
export default CmsRecommendedJobsBlock;
